import { render, staticRenderFns } from "./primary-borrower.vue?vue&type=template&id=66901100&"
import script from "./primary-borrower.vue?vue&type=script&lang=ts&"
export * from "./primary-borrower.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports